import React from "react";

import { Link } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

/** 戻るボタンのProps */
interface BackButtonProps {
    /** ボタン押下時の遷移先を表す、React Routerのパス */
    navigateTo: string;

    /**
     * ボタンに表示するラベル。(省略可)
     * ※省略時のラベルは「戻る」
     */
    label?: string;
}

/**
 * (共通)戻るボタン
 *
 * @param props Props
 * @returns 戻るボタンのReactコンポーネント
 * @see BackButtonProps
 */
const BackButton = (props: BackButtonProps) => {
    const { navigateTo, label = "戻る" } = props;
    return (
        <Link to={navigateTo} style={{ textDecoration: "none", color: "inherit", height: "100%" }}>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    "&:hover": {
                        cursor: "pointer",
                    },
                }}
            >
                <KeyboardArrowLeftIcon />
                <Typography>{label}</Typography>
            </Box>
        </Link>
    );
};

export default BackButton;
